import React, { memo } from 'react';
export function AgitationSection() {
  return <section className="py-16 md:py-20 px-4 sm:px-6 bg-dark-card/50 border-y border-dark-border" data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-text-primary" data-id="element-3">
          This is the most unfair part of all:
        </h2>
        <p className="text-lg md:text-xl text-text-secondary mb-6 leading-relaxed" data-id="element-4">
          The more you like her... the worse it gets.
        </p>
        <p className="text-base md:text-lg text-text-secondary mb-8 leading-relaxed" data-id="element-5">
          Because now it matters.
        </p>
        <p className="text-base md:text-lg text-text-secondary mb-5 leading-relaxed" data-id="element-6">
          And when it matters, the brain launches its emergency protocol:
        </p>

        <div className="bg-[#151820] border border-[#2a2d3a] p-5 md:p-6 rounded-xl mb-8 space-y-3" data-id="element-7">
          <p className="text-lg font-playfair italic text-text-primary" data-id="element-8">
            "Is it happening yet?"
          </p>
          <p className="text-lg font-playfair italic text-text-primary" data-id="element-9">
            "Is she counting the time?"
          </p>
          <p className="text-lg font-playfair italic text-text-primary" data-id="element-10">
            "What is she thinking when she looks at me?"
          </p>
          <p className="text-lg font-playfair italic text-text-primary" data-id="element-11">
            "Am I enough?"
          </p>
        </div>

        <p className="text-base md:text-lg text-text-secondary mb-6 leading-relaxed" data-id="element-12">
          You read her face like it's a verdict. Every silence becomes evidence.
          Every passing second is a countdown.
        </p>
        <p className="text-lg md:text-xl text-text-primary font-medium mb-6 leading-relaxed" data-id="element-13">
          And the most devastating part isn't that night.{' '}
          <span className="text-gold" data-id="element-14">It's the next one.</span>
        </p>
        <p className="text-base md:text-lg text-text-secondary mb-8 leading-relaxed" data-id="element-15">
          Because one bad night creates a memory. And that memory becomes an
          expectation. And that expectation shows up before she even touches
          you.
        </p>
        <div className="text-center mt-10" data-id="element-16">
          <p className="text-xl md:text-2xl font-playfair font-bold text-gold" data-id="element-17">
            You're no longer in the room with her. You're on trial.
          </p>
        </div>
      </div>
    </section>;
}